import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiEndpointsService } from './core/services/api-endpoints.service';
import { IHttpService } from './core/services/ihttp.service';
import { environment } from 'src/environments/environment';
import { DataService } from './core/services/data.service';
import { MsalService } from '@azure/msal-angular';
import { loginRequest } from './auth-config';
import { Router } from '@angular/router';
import { GoogleMapsLoaderService } from './core/services/google-maps.service';
import { UserSSOModel } from './core/classes/userSSO';

class AuthResult {
  access_token: string;
  idToken: string;
  expires_in: Date;
  token_type: string;
  scopes: string[];
}

@Component({
  selector: 'dq-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'affinity-DQ';
  constructor(
    private mapLoader: GoogleMapsLoaderService,
    private dataService: DataService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private apiEndpointsService: ApiEndpointsService,
    private msalService: MsalService,
    private router: Router,
    @Inject('HttpService') private httpService: IHttpService
  ) {
    translate.setDefaultLang('es');

    let auth: string = btoa(
      environment.CLIENT_ID + ':' + environment.CLIENT_SECRET
    );

    this.httpService
      .post(this.apiEndpointsService.getTokeEndPoint(), '', {
        headers: {
          Accept: 'application/json;charset=utf8',
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Basic ' + auth,
        },
      })
      .subscribe((result) => {
        //console.log(this.decodeJwt(result.access_token));
        this.dataService.setTokenSAP(result);
      });
  }

  async ngOnInit() {
    this.mapLoader.load();
    const result = await this.msalService.instance.handleRedirectPromise();

    if (result) {
      //console.log('✅ Login redirect exitoso', result.account);

      if (result?.account) {
        this.msalService.instance.setActiveAccount(result.account);

        const tokenResponse =
          await this.msalService.instance.acquireTokenSilent({
            ...loginRequest,
            account: result.account,
          });

        const user = new UserSSOModel(result.idTokenClaims, tokenResponse.accessToken);
        this.dataService.setUserSSO(user);

        console.log('Dominio del usuario:', user.domain);
        console.log('Es Manager?', user.isManager);

        const auth: any = {
          access_token: tokenResponse.accessToken,
        };
      }

      this.router.navigate(['/']);
    } else {
      const accounts = this.msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        //console.log('👤 Usuario ya logueado', accounts[0]);
        this.msalService.instance.setActiveAccount(accounts[0]);

        const account = accounts[0];

        const tokenResponse =
          await this.msalService.instance.acquireTokenSilent({
            ...loginRequest,
            account,
          });
        // console.log(
        //   '🎯 Token de acceso (sesión existente):',
        //   tokenResponse.accessToken
        // );
        const auth: any = {
          access_token: tokenResponse.accessToken,
        };

        const user = new UserSSOModel(account.idTokenClaims, tokenResponse.accessToken);
        this.dataService.setUserSSO(user);

        console.log('Dominio del usuario:', user.domain);
        console.log('Es Manager?', user.isManager);

        this.router.navigate(['/']);
      } else {
        this.msalService.loginRedirect(loginRequest);
      }
    }
  }

  decodeJwt(token: string): any {
    try {
      const payload = token.split('.')[1]; // tomamos la segunda parte
      const decodedPayload = atob(payload); // decodificamos base64
      return JSON.parse(decodedPayload); // parseamos a objeto
    } catch (e) {
      console.error('Error decodificando JWT', e);
      return null;
    }
  }
}
